/* eslint-disable import/no-anonymous-default-export */
import axios from "../utils/axios";
import ApiTokenSupport from "./token.support";
import { RegisterData } from "../interfaces/user.interface";
import { HubspotContactData } from "../components/modals/LoginRegisterModal/LoginRegisterModal";

class UserApi extends ApiTokenSupport {
  async login(email: string, password: string): Promise<string> {
    const resp = await axios.post<string>("/api/mortgageNotes/user/login", {
      email,
      password,
    });
    return resp.data;
  }

  async createOneTimePassword(email: string): Promise<string> {
    const resp = await axios.post<string>(
      `/api/mortgageNotes/user/create-one-time-password`,
      { email }
    );
    return resp.data;
  }

  async loginWithEmail(
    email: string,
    oneTimePassword: string
  ): Promise<string> {
    const resp = await axios.post<string>(
      `/api/mortgageNotes/user/login-with-email`,
      { email, oneTimePassword }
    );
    return resp.data;
  }

  async register(
    data: RegisterData
  ): Promise<{ success: boolean; token: string; error: string }> {
    const resp = await axios.post<{
      success: boolean;
      token: string;
      error: string;
    }>("/api/mortgageNotes/user/register", {
      ...data,
    });
    return resp.data;
  }

  async recoverPassword(email: string): Promise<boolean> {
    const resp = await axios.post<boolean>(
      `/api/mortgageNotes/user/recover-password`,
      {
        email,
        origin: "income-note-exchange",
      }
    );
    return resp.data;
  }

  /**
   * Reset password
   * @param email
   * @returns
   */
  async resetPassword(
    newPassword: string,
    token: string
  ): Promise<{ success: boolean; message: string }> {
    const resp = await axios.post<{
      success: boolean;
      message: string;
    }>(`/api/mortgageNotes/user/reset-password`, {
      newPassword,
      token,
    });
    return resp.data;
  }

  async verifyPasswordResetToken(
    token: string
  ): Promise<{ success: boolean; message: string }> {
    const resp = await axios.post<{
      success: boolean;
      message: string;
    }>(`/api/mortgageNotes/user/verify-reset-password-token`, {
      token,
    });
    return resp.data;
  }

  async setPassword(password: string, token: string): Promise<string> {
    const resp = await axios.post<string>(
      `/api/mortgageNotes/admin/set-password`,
      {
        password,
        token,
      }
    );
    return resp.data;
  }

  async checkHubspotEmail(email: string): Promise<any> {
    const resp = await axios.post(
      `/api/mortgageNotes/user/check-hubspot-email`,
      { email }
    );
    return resp.data;
  }

  async createHubspotContact(
    data: HubspotContactData & { email: string }
  ): Promise<any> {
    const resp = await axios.post(
      `/api/mortgageNotes/user/create-hubspot-contact`,
      data
    );
    return resp.data;
  }

  async fetchUserData(userID: number): Promise<any> {
    const resp = await axios.get(`/api/mortgageNotes/user/${userID}`);
    return resp.data;
  }

  async saveUserData(userID: number, data: any): Promise<any> {
    const resp = await axios.put(`/api/mortgageNotes/user/${userID}`, data);
    return resp.data;
  }

  async refreshAuthToken(): Promise<{ token: string }> {
    const resp = await axios.post<{ token: string }>(
      `/api/mortgageNotes/user/refresh-auth-token`,
      {},
      this.withAuthorization()
    );
    return resp.data;
  }
}

export default new UserApi();
